const ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  DEV1: 'dev1',
  DEV2: 'dev2',
  DEV3: 'dev3',
  STAGING: 'staging',
  PRODUCTION: 'production'
};

export { ENVIRONMENTS };
